export default {
  searchText: '',
  orderName: 1,
  fieldType: 0,
  varietyId: 0,
  gradeId: 0,
  stageId: 0,
  riskId: 0,
  choiceFieldId: 0,
  beforeRecordDate: 0
}
